var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"v-multiselect__options-item",class:{ 'v-multiselect__options-item--selected': _vm.isSelected },on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.item[_vm.itemName]))])
}
var staticRenderFns = []

export { render, staticRenderFns }